<template>
  <div class="row">
    <div class="col-md-12">
      <section
        class="elementor-section elementor-top-section elementor-element elementor-element-7cb399c elementor-section-full_width elementor-section-stretched elementor-section-height-default elementor-section-height-default default"
        data-id="7cb399c"
        data-element_type="section"
        data-settings='{"stretch_section":"section-stretched"}'
      >
        <div class="elementor-container elementor-column-gap-no">
          <div
            class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-603ab00"
            data-id="603ab00"
            data-element_type="column"
          >
            <div class="elementor-widget-wrap elementor-element-populated">
              <div
                class="elementor-element elementor-element-3c87bcc elementor-widget elementor-widget-banner-slider-two"
                data-id="3c87bcc"
                data-element_type="widget"
                data-widget_type="banner-slider-two.default"
              >
                <div class="elementor-widget-container">
                  <div
                    class="swiper banner-swiper banner-slider banner-slider-two"
                    data-swiper='{"spaceBetween":0,"slidesPerView":1,"autoHeight":true,"loop":true,"effect":"fade","pagination":{"el":"#banner-pagination","clickable":true},"autoplay":{"delay":7000},"speed":1000}'
                  >
                    <div class="swiper-wrapper">
                      <div class="swiper-slide active">
                        <div
                          class="slider-img"
                          style="
                            background-image: url(http://devcdn.wistirna.com/assets/majestic/slider01.jpg);
                          "
                        ></div>
                        <div class="slider-overlay"></div>
                        <div class="banner-content">
                          <div class="banner-text">
                            <h6 class="mb-3">
                              <span>Majestic</span>Flexible Courier Services
                            </h6>
                            <h1 class="mb-4">
                              International Parcel
                              <span class="title-text">Made Easy</span>
                            </h1>
                            <p>
                              Experience hassle-free courier service with our solutions that prioritize your needs.
                            </p>
                            <div class="banner-btn">
                                      <a href="" class="themeht-btn primary-alt"><span>Book Now!</span><i class="flaticon flaticon-double-chevron"></i></a>
                                       
                                  </div>
                          </div>
                        </div>
                      </div>
                      <!-- <div class="swiper-slide">
                        <div
                          class="slider-img"
                          style="
                            background-image: url(https://moverz.themeht.com/wp-content/uploads/2024/11/slider02.jpg);
                          "
                        ></div>
                        <div class="slider-overlay"></div>
                        <div class="banner-content">
                          <div class="banner-text">
                            <h6 class="mb-3">
                              <span>Moverz</span>Secure &amp; Reliable shipping
                            </h6>
                            <h1 class="mb-4">
                              We Make Moving
                              <span class="title-text">Cheap &amp; Safe.</span>
                            </h1>
                            <p>
                              Experience hassle-free journeys with our transport
                              solutions that prioritize your comfort. vitae mi
                              congue aliquet eu suspendisse eleifend turpis.
                            </p>
                            <div class="banner-btn">
                              <a class="themeht-btn primary-btn">
                                <span>Learn More</span>
                                <i class="flaticon flaticon-double-chevron"></i>
                              </a>
                              <a class="video-btn popup-youtube">
                                <div class="video-btn-icon">
                                  <i class="flaticon flaticon-play"></i>
                                </div>
                                <span>Watch Now</span>
                              </a>
                            </div>
                          </div>
                        </div>
                      </div> -->
                    </div>
                    <div class="swiper-nav-dots">
                      <div
                        id="banner-pagination"
                        class="swiper-pagination"
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <div class="form-direction">
      <div class="mt-3 form-quate">
        <div class="d-flex flex-wrap gap-2">
          <v-btn :class="{ 'change-btn': btnSelect }" @click="btnSelect = true">
            Book Your Parcel
          </v-btn>

          <v-btn
            :class="{ 'change-btn': !btnSelect }"
            @click="btnSelect = false"
            >Track Your Parcel</v-btn
          >
        </div>
        <div v-if="btnSelect">
          <requestFormSmall></requestFormSmall>
        </div>
        <div v-else>
          <trackingForm />
        </div>
      </div>
    </div>
  </div>

  <div class="mt-5">
    <homepage2 />
  </div>
  <div class="mt-5">
    <homepage3 />
  </div>
  <div class="mt-5 m-2">
    <homepage4 />
  </div>
  <div class="mt-5 m-2">
    <homepage5 />
  </div>
</template>

<script >
import requestFormSmall from "@/components/requestFormSmall.vue";
import trackingForm from "@/components/trackingForm.vue";
import homepage2 from "@/components/homePage2.vue";
import homepage3 from "@/components/homePage3.vue";
import homepage4 from "@/components/homePage4.vue";
import homepage5 from "@/components/homePage5.vue";
import Swiper, { Pagination, Autoplay, EffectFade } from "swiper";
import "swiper/swiper-bundle.css";

Swiper.use([Pagination, Autoplay, EffectFade]);

// Example slides
export default {
  components: {
    requestFormSmall,
    trackingForm,
    homepage2,
    homepage3,
    homepage4,
    homepage5,
  },

  data() {
    return {
      btnSelect: true,
      btnSelect1: false,
    };
  },
  mounted() {
    new Swiper(".banner-swiper", {
      spaceBetween: 0,
      slidesPerView: 1,
      autoHeight: true,
      loop: true,
      effect: "fade",
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      autoplay: {
        delay: 7000,
      },
      speed: 1000,
    });
  },
};
</script>


<style scoped>
@import "@/assets/theme-style6c2d.css";

.swiper-button-prev {
  display: none;
}
.change-btn {
  background-color: #e11c09;
  border-radius: 0px;
  color: white !important;
}
.form-quate {
  background-color: #fff !important;
  box-shadow: 0 0 5px 2px #605e5e;
  border: 5px solid #e11c09;
  width: 595px;
}
.form-direction {
  position: absolute;
  right: 45px;
  margin-top: 30px;
  top: 325px;
  z-index: 1;
  display: flex;
  justify-content: end;
}
</style>
